import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    margin: theme.spacing(0, 0, 2),
    borderRadius: 10,
    border: `1px solid ${theme.palette.warning.main}`,
    backgroundColor: alpha(theme.palette.warning.main, UiAlpha.Tint),
  },
  icon: {
    flexShrink: 0,
    width: 24,
    height: 24,
    color: theme.palette.warning.main,
  },
  text: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(0.5),
  },
  description: {
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
  inlineCode: {
    display: 'inline',
    fontFamily: 'ui-monospace, monospace',
    fontSize: '0.875em',
    padding: '2px 6px',
    borderRadius: 10,
    backgroundColor: alpha(theme.palette.text.primary, UiAlpha.Subtle),
  },
}));
